import * as React from 'preact/compat'
import type { JSXInternal } from 'preact/src/jsx'

import { sgVersion } from '#js/common/helpers'

import commonCss from '#css/common.pcss.json'

type SVGProps = JSXInternal.HTMLAttributes<SVGSVGElement> & { i: string, adaptive?: boolean }

const requestedIcons = []

export const preloadIcon = (i: string) => {
  const domain = globalThis.sgDomain || ''
  const found = document.querySelector(`[id="${i}"]`)

  if (!found && !requestedIcons.includes(i)) {
    requestedIcons.push(i)
    const version = sgVersion()
    fetch(domain + `/img/svg/${i}.svg?${version}`)
      .then(res => res.text())
      .then(svg => {
        if (document.querySelector(`[id="${i}"]`)) {
          return
        }
        const div = document.createElement('div')
        let svgSprite = document.querySelector('#svg-sprite')
        if (!svgSprite) {
          svgSprite = document.createElement('svg')
          svgSprite.setAttribute('width', '0')
          svgSprite.setAttribute('height', '0')
          svgSprite.setAttribute('id', 'svg-sprite')
          svgSprite.setAttribute('style', 'position: absolute; bottom: 0;')
          document.body.appendChild(svgSprite)
        }
        div.innerHTML = svg
        const svgElement = div.querySelector('svg')
        if (svgElement) {
          const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')
          symbol.setAttribute('id', i)
          Array.from(svgElement.attributes).forEach(attr => {
            symbol.setAttribute(attr.name, attr.value)
          })
          Array.from(svgElement.children).forEach(child => {
            symbol.appendChild(child)
          })
          svgSprite.appendChild(symbol)
        }
      })
  }
}

export default ({ i, adaptive, ...attributes }: SVGProps) => {
  if (!adaptive) {
    preloadIcon(i)
    return <svg {...attributes}><use href={`#${i}`} /></svg>;
  }

  const icons = {
    default: i,
    large: `${i}-large`,
    small: `${i}-small`
  }

  const useString = []
  for (let size in icons) {
    preloadIcon(icons[size])
    useString.push(<use className={commonCss[`adaptive-icon__${size}`]} href={`#${icons[size]}`} />)
  }

  if (!attributes.className) {
    attributes.className = '';
  }

  attributes.className += ' ' + commonCss['adaptive-icon']

  return <svg {...attributes}>{useString}</svg>
}
